module.exports = __webpack_public_path__ + "static/media/Mallards-Pond-Master-Deed.d93b5ffb.pdf";